<template>
   <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
    <!-- Content Header (Page header) -->
        <div v-if="$gate.isInstallationAgent()">
<!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

    <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h2>Service Manager Home</h2>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item"><a href="/home">Home</a></li>
                <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
              </ol>
            </div>
          </div>
        </div><!-- /.container-fluid -->
      </section>

    <!-- Main content -->
    <section class="content">
<br>
<div class="col-md-11">
  <br>
<h5><b>Job Statistics</b></h5>
<br>
<h4>Today in your branch</h4>
<br>
<div class="row" align="center">

 <div class="col-lg-4 col-6">
            <!-- small box -->
            <div class="small-box bg-danger" @click="getJobs('', 'today')">
              <div class="inner">
                <h3>{{today}}</h3>

                <p>New</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-4 col-6" @click="getJobs('Pending', 'today')">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{pending}}</h3>
                <p>Pending</p>
              </div>
              <div class="icon">
                <i class="ion ion-pie-graph"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-4 col-6" @click="getJobs('Completed', 'today')">
            <!-- small box -->
            <div class="small-box bg-danger">
              <div class="inner">
                <h3>{{completed}}</h3>
                <p>Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          </div>
          <br>
          <h4>This Month in your branch</h4>
          <br>

        <div class="row">
          <div class="col-lg-6 col-6">
            <!-- small box -->
            <div class="small-box bg-danger" @click="getJobs('', 'month')">
              <div class="inner">
                <h3>{{monthnew}}</h3>
                <p>New</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-6 col-6">
            <!-- small box -->
            <div class="small-box bg-danger" @click="getJobs('Pending', 'month')">
              <div class="inner">
                <h3>{{monthpending}}</h3>
                <p>Pending</p>
              </div>
              <div class="icon">
                <i class="ion ion-person-add"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>

          <div class="col-lg-6 col-6">
            <!-- small box -->
            <div class="small-box bg-danger" @click="getJobs('Completed', 'month')">
              <div class="inner">
                <h3>{{monthcompleted}}</h3>
                <p>Completed</p>
              </div>
              <div class="icon">
                <i class="ion ion-bag"></i>
              </div>
              <!-- <a href="#" class="small-box-footer">More info <i class="fas fa-arrow-circle-right"></i></a> -->
            </div>
          </div>



<!-- content here -->

</div>

</div>

<!-- content here -->

<!-- row end -->
    </section>
    <!-- /.content -->



<!-- All VUE Parts end before this comment -->
        </div>
        <div v-if="!$gate.isInstallationAgent()">
             <access-denied></access-denied>
        </div>
    </div>
</template>

<script>
    export default {
        mounted() {
            console.log('Component mounted.')
        },

        created(){
        	this.getCount();
        },

        data(){
        	return {
        		today: '-',
        		pending: '-',
        		completed: '-',
        		monthnew: '-',
        		monthcompleted: '-',
        		monthpending: '-',
        		dailyrevenue: '-',
        		monthlyrevenue: '-',
        		dailyprofit: '-',
        		monthlyprofit: '-'
        	}
        },

        methods: {
        	getCount(){
        		axios.post("/api/getManagerCount")
        		.then(response => {
        			this.today = response.data.today;
        			this.completed = response.data.completed;
        			this.pending = response.data.pending;
        			this.monthnew = response.data.monthnew;
        			this.monthcompleted = response.data.monthcompleted;
        			this.monthpending = response.data.monthpending;
        			this.dailyrevenue = response.data.dailyrevenue;
        			this.monthlyrevenue = response.data.montlyrevenue;
        			this.dailyprofit = response.data.dailyprofit;
        			this.monthlyprofit = response.data.monthlyprofit;
        		})
        	},

        	getJobs(status, time){
        		if(time == 'today'){
        			var date = new Date();
							const today=new Date(date.getTime() - (date.getTimezoneOffset() * 60000 ))
				                .toISOString()
				                .split("T")[0];
				      this.$router.push({
				      	name: 'Job Report | Service Manager',
				      	params: {status:status, from:today, to:today}
				      });
        		}
        		else if(time == 'month'){
		      		var date = new Date(), y = date.getFullYear(), m = date.getMonth();
							var firstDay = new Date(y, m, 1);
							var lastDay = new Date(y, m + 1, 0);
				      this.$router.push({
				      	name: 'Job Report | Service Manager',
				      	params: {status:status, from:firstDay, to:lastDay}
				      });
        		}
        	}
        }
    }
</script>
